const LinkContent = ({content, linkUrl}) => {
    return ( <>
    {content && <div className="__body">{content}</div>}
    {linkUrl ? <a className="__content-link" href={linkUrl} target="_blank" rel="noreferrer">Open link</a> : <></>}
</> );
}
 
export default LinkContent;